module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Sorry! We encountered an unexpected error.","description":"Please try back again shortly.","buttonText":"Back to home"},"zh":{"title":"我们遇到了意外错误。","description":"请稍后再试。","buttonText":"返回主页"},"kr":{"title":"죄송합니다! 예기치 않은 오류가 발생했습니다.","description":"잠시 후 다시 시도하십시오.","buttonText":"홈으로"}}')
  delete Component.options._Ctor
}
